import { useUpdate } from "@refinedev/core";
import type { IconComponent } from "@/components/ui/icon";

import { Button } from "@/components/ui/button";

export interface StatusActionProps {
  resource: string;
  id: string;
  /** The `status` value to PATCH onto the record. */
  toStatus: string;
  /** Which column to set (default `status`). */
  field?: string;
  label: string;
  icon?: IconComponent;
  variant?:
    | "default"
    | "outline"
    | "secondary"
    | "destructive"
    | "ghost";
  /** Called after a successful mutation (e.g. to refetch the record). */
  onDone?: () => void;
}

/**
 * Button that PATCHes a single status field on a record via the Refine
 * dataProvider (`update` → `PATCH /api/{resource}/{id}`). Used for the skill
 * approval workflow (draft → review → published → archived) and rule
 * enable/disable.
 */
export function StatusAction({
  resource,
  id,
  toStatus,
  field = "status",
  label,
  icon: Icon,
  variant = "default",
  onDone,
}: StatusActionProps) {
  const { mutate, isLoading } = useUpdate();
  return (
    <Button
      variant={variant}
      size="sm"
      disabled={isLoading}
      onClick={() =>
        mutate(
          {
            resource,
            id,
            values: { [field]: toStatus },
          },
          { onSuccess: () => onDone?.() },
        )
      }
    >
      {Icon ? <Icon className="mr-2 h-4 w-4" /> : null}
      {label}
    </Button>
  );
}

export default StatusAction;
